import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

function Navigation() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <nav className="bg-white shadow-md" data-testid="navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-8">
            <Link to="/" className="text-2xl font-bold text-blue-600" data-testid="nav-home">
              ServiceHub
            </Link>
            <Link to="/browse" className="text-gray-700 hover:text-blue-600" data-testid="nav-browse">
              Browse Services
            </Link>
          </div>

          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  className="text-gray-700 hover:text-blue-600"
                  data-testid="nav-dashboard"
                >
                  Dashboard
                </Link>
                {user?.role === 'provider' && (
                  <Link
                    to="/create-service"
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    data-testid="nav-create-service"
                  >
                    Create Service
                  </Link>
                )}
                <div className="flex items-center gap-3">
                  {user?.picture && (
                    <img
                      src={user.picture}
                      alt={user.name}
                      className="w-8 h-8 rounded-full"
                      data-testid="user-avatar"
                    />
                  )}
                  <span className="text-gray-700" data-testid="user-name">{user?.name}</span>
                  <button
                    onClick={handleLogout}
                    className="text-gray-600 hover:text-red-600"
                    data-testid="nav-logout"
                  >
                    Logout
                  </button>
                </div>
              </>
            ) : (
              <button
                onClick={handleLogin}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                data-testid="nav-login"
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;